import { Component, Input } from '@angular/core';
import { MatChipEvent } from '@angular/material/chips';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

import { upsertNotesFilters } from '@modules/notes/filters-store/notes-filters.actions';
import { selectActiveNotesFilters } from '@modules/notes/filters-store/notes-filters.selectors';
import { NotesFiltersInterface } from '@modules/notes/filters-store/notes-filters.service';
import { NoteSubject } from 'mojo-irp-notes';
import { isTruthy } from '@shared';
import { RouteParamsService } from '@shared/services/route-params.service';
import { hasAnonymization } from '@collections/users';

@Component({
  selector: 'mojo-notes-keyword-search',
  templateUrl: './notes-keyword-search.component.html',
  styleUrls: ['./notes-keyword-search.component.scss'],
})
export class NotesKeywordSearchComponent {
  @Input() notesType: NoteSubject;

  hasAnonymization$ = this.store.select(hasAnonymization);
  activeNotesFilters$: Observable<NotesFiltersInterface> = this.store
    .select(selectActiveNotesFilters)
    .pipe(
      filter(isTruthy),
      tap((filters) => (this.activeNotesFilters = filters)),
    );

  activeNotesFilters: NotesFiltersInterface;

  constructor(
    private store: Store,
    private route: ActivatedRoute,
    private routeParamsService: RouteParamsService,
  ) {}

  clearSearchPhrase() {
    this.store.dispatch(
      upsertNotesFilters({
        notesFilters: {
          ...this.activeNotesFilters,
          searchPhrases: [],
        },
      }),
    );
  }

  addSearchStringQuill($event: string) {
    const searchTerm = $event.toLowerCase();
    this.addSearchTerm(searchTerm, $event);
  }

  addSearchItemQuill($event: any) {
    const searchTerm = `[${$event.denotationChar}${$event.id}:${$event.value}]`;
    this.addSearchTerm(searchTerm, searchTerm);
  }

  private addSearchTerm(searchTerm, term) {
    if (!this.activeNotesFilters.searchPhrases.includes(searchTerm)) {
      const newTerms = [...this.activeNotesFilters.searchPhrases, term];
      this.routeParamsService.updateRouteParams({ searchPhrases: newTerms }, this.route);
      this.store.dispatch(
        upsertNotesFilters({
          notesFilters: {
            ...this.activeNotesFilters,
            searchPhrases: newTerms,
          },
        }),
      );
    }
  }

  removeSearchPhrase($event: MatChipEvent, value: string) {
    const newTerms = this.activeNotesFilters.searchPhrases.filter((phrase) => phrase !== value);
    this.routeParamsService.updateRouteParams({ searchPhrases: newTerms }, this.route);
    this.store.dispatch(
      upsertNotesFilters({
        notesFilters: {
          ...this.activeNotesFilters,
          searchPhrases: newTerms,
        },
      }),
    );
  }

  get showMentionTags() {
    return this.notesType === NoteSubject.Job || this.notesType === NoteSubject.JobHiringManager;
  }
}
